import { render, staticRenderFns } from "./IconBaseButton.vue?vue&type=template&id=844d0d90"
import script from "./IconBaseButton.vue?vue&type=script&lang=js"
export * from "./IconBaseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports